module.exports = __webpack_public_path__ + "static/media/icons-door.5412df42.svg";